import React, {type ComponentPropsWithoutRef} from 'react';
import {EzPageHeader} from '@ezcater/recipe';
import {useTranslation} from 'react-i18next';
import {Link, useLocation} from 'react-router-dom';
import {DELIVERY_MANAGEMENT_DELIVERIES_PATH, DELIVERY_MANAGEMENT_DRIVERS_PATH} from '../../paths';

type EzPageHeaderProps = ComponentPropsWithoutRef<typeof EzPageHeader>;

type PageLayoutHeaderProps = Omit<EzPageHeaderProps, 'subnav' | 'title'> & {
  title?: string;
};

const PageLayoutHeader = ({...props}: PageLayoutHeaderProps) => {
  const location = useLocation();
  const {t} = useTranslation();

  const tabs = [
    {
      label: t('components.deliveryManagement.pageLayoutHeader.deliveriesTabLabel'),
      to: DELIVERY_MANAGEMENT_DELIVERIES_PATH,
      as: Link,
    },
    {
      label: t('components.deliveryManagement.pageLayoutHeader.driversTabLabel'),
      to: DELIVERY_MANAGEMENT_DRIVERS_PATH,
      as: Link,
    },
  ];
  const selectedSubNav = tabs.find(tab => location.pathname.includes(tab.to));

  const defaultPageTitle = t('components.deliveryManagement.pageLayoutHeader.defaultTitle');
  const pageTitle = selectedSubNav?.label || defaultPageTitle;

  return <EzPageHeader {...props} title={pageTitle} />;
};

export default PageLayoutHeader;
